import { render, staticRenderFns } from "./CarePlanItem.vue?vue&type=template&id=53d72bc8"
import script from "./CarePlanItem.vue?vue&type=script&lang=ts"
export * from "./CarePlanItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports